import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast, Toaster } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import logoAlbaker from "@/assets/logo-albaker.png";
import { ArrowUpRight } from "lucide-react";

const Register = () => {
  const { register, formatApiError } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", confirm: "" });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 8) {
      toast.error("كلمة المرور يجب أن تكون ٨ أحرف على الأقل");
      return;
    }
    if (form.password !== form.confirm) {
      toast.error("كلمتا المرور غير متطابقتين");
      return;
    }
    setLoading(true);
    try {
      await register(form.name.trim(), form.email.trim(), form.password);
      toast.success("تم إنشاء حسابك");
      navigate("/");
    } catch (err) {
      toast.error(formatApiError(err, "تعذّر إنشاء الحساب"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div dir="rtl" className="min-h-screen bg-ink text-bone flex items-center justify-center container-x py-20">
      <Toaster position="top-left" theme="dark" richColors />
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-3 mb-12">
          <img src={logoAlbaker} alt="Albaker" className="h-10 w-auto" />
          <span className="overline">العودة للموقع</span>
        </Link>

        <div className="overline mb-4">إنشاء حساب</div>
        <h1 className="font-arabic font-black text-4xl sm:text-5xl text-bone leading-[1.15] mb-10">
          أنشئ حسابك.
        </h1>

        <form onSubmit={onSubmit} className="space-y-7" data-testid="register-form">
          <Field label="الاسم الكامل" testId="register-name" value={form.name} onChange={(v) => setForm((f) => ({ ...f, name: v }))} required />
          <Field label="البريد الإلكتروني" type="email" testId="register-email" value={form.email} onChange={(v) => setForm((f) => ({ ...f, email: v }))} required ltr />
          <Field label="كلمة المرور (٨+ أحرف)" type="password" testId="register-password" value={form.password} onChange={(v) => setForm((f) => ({ ...f, password: v }))} required ltr />
          <Field label="تأكيد كلمة المرور" type="password" testId="register-confirm" value={form.confirm} onChange={(v) => setForm((f) => ({ ...f, confirm: v }))} required ltr />

          <button type="submit" disabled={loading} className="btn-gold group disabled:opacity-60" data-testid="register-submit">
            <span>{loading ? "جاري الإنشاء…" : "إنشاء الحساب"}</span>
            <ArrowUpRight size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </button>
        </form>

        <div className="mt-10 pt-8 border-t border-white/10 text-sm text-white/55 font-arabic">
          لديك حساب؟{" "}
          <Link to="/login" className="text-gold hover:text-gold-light transition-colors">
            تسجيل الدخول
          </Link>
        </div>
      </div>
    </div>
  );
};

const Field = ({ label, type = "text", value, onChange, testId, required, ltr }) => (
  <label className="block">
    <span className="block mb-2 text-xs tracking-[0.2em] uppercase text-white/50">{label}</span>
    <input
      type={type}
      required={required}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="editorial-input"
      data-testid={testId}
      dir={ltr ? "ltr" : "auto"}
    />
  </label>
);

export default Register;
